<template>
    <section v-if="paperData" :class="setTabFixed  ? 'fixed-bottom' : ''">
        <!-- <hr class="divider shadow"> -->
        <div class="d-flex flex-row justify-content-between pdt-10 pdb-10 pdl-16 pdr-16 bottom-shadow footer-wrapper" v-if="paperData.goods && !examineeId">
            <div class="t-headline5 pdt-2 pdb-2" v-if="isCharged">
                <span class="t-body3 unit">
                    {{paperData.goods.currency.key || 'USD'}}
                </span>
                {{$n(paperData.goods.paymentPrice)}}
            </div>
            <div class="t-headline5 pdt-2 pdb-2" v-else>
                 {{$t('1010')}}
                <!-- Free -->
            </div>

            <div v-if="!examineeId">
                <!-- {{isCharged}} -->
                <button class="mdc-button mdc-button--raised btn-red" 
                    v-if="isCharged"
                    @click="buyExam()"
                >
                    {{$t('1002')}}
                    <!-- 구매하기 -->
                </button>

                <button class="mdc-button mdc-button--raised btn-red" 
                    v-else
                    @click="buyExam()"
                >
                    {{$t('1011')}}
                    <!-- 신청하기 -->
                </button>
            </div>
            <div v-else>
                <div v-for="(action, index) in actions" :key="index">
                    <!-- {{setButtonActionName(action)}}dddddd -->
                    <button class="mdc-button mdc-button--raised btn-red" :disabled="setButtonDisabled(action)" @click="examAction(action)">
                        {{setButtonActionName(action)}}
                    </button>    
                </div>
                <!-- {{isCharged}} -->
            </div>

            
        </div>
    </section>

    
</template>

<script>
import ViewHeader from './Header.vue'
import {MDCRipple} from '@material/ripple'
export default {
    props: ['setTabFixed'],
    extends: ViewHeader,
    mounted() {
        this.setMaterialUi()
    },
    methods: {
        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
    }
}
</script>

<style>

</style>